<template>
  <div class="nav">
    <el-row class="content">
      <el-col :span="5" class="lt">
        <div class="logo" @click="handleBackToHome">
          <img src="../assets/logo.png" alt="">
        </div>
      </el-col>
      <el-col :span="19" class="rt">
        <ul class="tabs">
          <li class="tab" v-for="item in tabsList" :key="item.id" @click="handleClickTab(item.url, item.id)" :class="activeClass == item.id ? 'active':''">
            {{item.name}}
          </li>
          <li><el-button class="btn-link" @click="handleToMerchant">商家入口</el-button></li>
        </ul>
        <el-dropdown>
          <span class="el-dropdown-link" @click="handleDropdownIcon">
            <img class="nav-icon" src="@/assets/svg/navigation.svg" alt="" srcset="">
          </span>
          <el-dropdown-menu slot="dropdown" :class="{'display-none': displayNone}">
            <el-dropdown-item  v-for="item in tabsList" :key="item.id" @click.native="handleClickTab(item.url, item.id)"  :class="activeClass == item.id ? 'active':''">{{item.name}}</el-dropdown-item>
            <el-dropdown-item divided  @click.native="handleToMerchant">商家入口</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'HeaderNav',
  data () {
    return {
      activeName: '1',
      tabsList: [
        {
          id: '1',
          name: '首页',
          url: '/'
        }, {
          id: '2',
          name: '产品介绍',
          url: '/product'
        }, {
          id: '3',
          name: '关于我们',
          url: '/about'
        },
        {
          id: '4',
          name: '帮助中心',
          url: '/help'
        }
      ],
      showDropdown: false,
      displayNone: true
    }
  },
  props: {
    linkId: {
      type: String,
      required: true
    }
  },
  created () {
    this.activeClass = this.linkId
  },
  mounted() { // dropdown
    window.addEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      this.displayNone = true
    },
    handleDropdownIcon() {
      this.displayNone = !this.displayNone
    },
    handleClickTab(url, id) {
      this.activeClass = id
      this.$router.push(url)
      window.scrollTo(0, 0)
    },
    goHome () {
      this.$router.push('/home')
    },
    handleToMerchant() {
			window.open('https://shanghu.jupiaotong.cn/')
    },
    handleBackToHome() {
      window.scrollTo(0, 0)
      this.$router.push('/')
    }
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style lang="less" scoped>
.nav {
  background:rgba(255,255,255,1);
  box-shadow:0px 4px 9px 0px rgba(4,0,0,0.1);
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  z-index: 9999;
  /deep/ .el-dropdown {
    display: none;
  }
  .content {
    max-width: 12rem;
    margin: auto!important;
  }
  .lt {
    display: flex;
    justify-content: flex-start;
  }
  .rt {
    display: flex;
    justify-content: flex-end;
  }
  .logo {
    height: .7rem;
    display: flex;
    align-items: center;
    cursor: pointer;
    img {
      width: 1rem;
    }
  }
  .tabs {
    display: flex;
    font-size: .16rem;
    height: .7rem;
    line-height: .7rem;
    li {
      padding: 0 .18rem;
      &.active {
        border-bottom: .04rem solid #B71C22;
        color: #B71C22;
      }
      &:hover {
        color: #B71C22;
        cursor: pointer;
      }
    }
  }
  .btn-link {
    background: #B71C22;
    border: #B71C22;
    color: #fff;
    font-size: .16rem;
  }
  /deep/ .el-button {
    padding: .08rem .18rem;
  }
}
  @media (max-width:768px) {
    .nav{
      //padding: 0 .2rem;
      .tabs {
        display: none;
      }
      .el-dropdown {
        display: inline-block;
        .nav-icon {
          width: .3rem;
          height: .35rem;
          padding: .36rem .2rem .14rem;
        }
      }
      .logo {
        padding-left: .2rem;
        height: 1rem;
        img {
          width: 100%;
        }
      }
    }
    .el-dropdown-menu__item {
      font-size: .28rem;
      &.active {
        color:#B71C22;
      }
    }
    .el-dropdown-menu {
      width: 98%;
      left: .1rem;
      right: .1rem;
    }
    .el-dropdown-link {
      cursor: pointer;
      color: #B71C22;
      display: inline-block;
    }
    .el-dropdown-menu__item:focus, .el-dropdown-menu__item:not(.is-disabled):hover {
      background-color:#FFF1F0;
      color: #b71c22;
    }
    .display-none {
      display: none;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/Header.vue